import React from 'react';
import Button from 'react-bootstrap/Button';

import './list.css';

interface ListProps<T> {
  data: T[];
  handleUpdateRegister: (id: number, checked: boolean) => void;
  idField: keyof T; // Nome do campo que representa o ID
  nameField: keyof T; // Nome do campo que representa o nome
  checkedField: keyof T; // Nome do campo que representa o estado checked
}

const List = <T extends { [key: string]: any }>({
  data,
  handleUpdateRegister,
  idField,
  nameField,
  checkedField,
}: ListProps<T>): JSX.Element => {
  return (
    <div
      className="table-responsive overflow-hidden"
      style={{ borderRadius: '0.68rem', borderColor: 'transparent' }}
    >
      <table className="table table-hover table-nowrap mb-0 mt-1 table-striped-custom">
        <tbody
          className="text-dark"
          style={{ borderColor: 'transparent', fontSize: '1.25rem' }}
        >
          {data.map((item: T) => (
            <tr
              key={nameField.toString() + item[idField]}
              onClick={(e: any) => {
                if (
                  e.target.tagName !== 'INPUT' &&
                  e.target.tagName !== 'LABEL'
                ) {
                  handleUpdateRegister(
                    item[idField],
                    !(item[checkedField] === 'S')
                  );
                }
              }}
              style={{ cursor: 'pointer' }}
            >
              <td>{item[nameField]}</td>
              <td className="d-flex justify-content-end">
                <div className="custom-checkbox">
                  <input
                    key={nameField.toString() + item[idField]}
                    id={`checkbox-${item[idField]}+${nameField.toString()}`}
                    type="checkbox"
                    checked={item[checkedField] === 'S'}
                    onChange={(e) => {
                      handleUpdateRegister(item[idField], e.target.checked);
                    }}
                  />
                  {/* eslint-disable jsx-a11y/label-has-associated-control */}
                  <label
                    htmlFor={`checkbox-${
                      item[idField]
                    }+${nameField.toString()}`}
                  >
                    {' '}
                  </label>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default List;
